import { put, select } from 'redux-saga/effects'
import { PRESUPUESTADOR_CALCULATE_REMAINDER_SUCCESS } from '../constants'
import { calculateDiscounts, calculateRemainder } from '../../../common/Utilities'
import { SALE_TYPE } from 'common/Constants'

const getSaleType = (auto, tabSelected) => {
  if(auto.nuevo && tabSelected==='venta_directa') {
    return SALE_TYPE.DIRECT
  } else if(auto.nuevo && tabSelected==='venta_convencional') {
    return SALE_TYPE.CONVENTIONAL
  } else {
    return SALE_TYPE.USED
  }
}

export default function* calculateRemainderSaga() {
  
  let remainder = 0
  const presupuestador = yield select(state => state.presupuestador)
  const { selectedStock, special_discount, entregaUsados, nuevo, tipoVentaSelected, sumarCantidad } = presupuestador
  
  if(nuevo) {
    const stockList = nuevo?.Stocks || []
    const saleType = getSaleType(nuevo, tipoVentaSelected)
    let catalogData = nuevo
    if(selectedStock && stockList.length > 0 && saleType === SALE_TYPE.CONVENTIONAL){
      const stock = stockList.find(item => item.id === selectedStock)
      const dummyBon = {
        ...nuevo.bonification,
        specific_amount: stock.Bonification.specific_amount,
        specific_valid_to: stock.Bonification.specific_valid_to,
      }
      catalogData = {...nuevo, bonification: dummyBon}
    }
    
    const { maxDiscount, usedDiscount } = calculateDiscounts({
      catalog: catalogData,
      profileDiscounts: presupuestador.profileDiscounts,
      carLotId: nuevo?.car_lot_id,
      saleType,
      saleQuantity: sumarCantidad
    })
   
    remainder = calculateRemainder({
      discountNewVehicle: maxDiscount || 0, 
      specialDiscount: special_discount,
      discountUsedVehicle: usedDiscount || 0, 
      takingCars: entregaUsados,
      saleQuantity: sumarCantidad
    })

  }

  yield put({
    type: PRESUPUESTADOR_CALCULATE_REMAINDER_SUCCESS,
    data: { remainder }
  })

}